import React, { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { Typography, Button, Spinner, Input } from "@material-tailwind/react";
import { add_font_data, update_font } from '../../Controller/actions';
import { NewContext } from '../../Context/NewContext';
import { FileInput } from '../../Components/FileInput/FileInput'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Switch from '../Switch/Switch';


export const ThemeFontModel = () => {
    const { truncateString, isModalLoading, setFormData, setDeleteUpdateTag, deleteUpdateYes, handleSwitch, handleFileInput, setIsModalLoading, handleClose, formData, open, addEditDeleteTag, handleChange } = useContext(NewContext);

    useEffect(() => {
        if (addEditDeleteTag === `add`) setFormData({ ...formData, isActive: true })
    }, [addEditDeleteTag]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        let createUpdateSounds;
        setIsModalLoading(true);

        const obj = {
            fontSmallPreview: formData?.fontSmallPreview ? formData?.fontSmallPreview : [],
            fontBigPreview: formData?.fontBigPreview ? formData?.fontBigPreview : [],
            name: formData?.name,
            themeFont: formData?.themeFont,
            isActive: formData?.isActive ? true : false,
            isPremium: formData?.isPremium ? true : false,
            isTop: formData?.isTop ? true : false,
            isHot: formData?.isHot ? true : false,
            isLatest: formData?.isLatest ? true : false,
        }

        if (addEditDeleteTag == `update`) {
            createUpdateSounds = await update_font(obj, formData?._id)
        } else {
            createUpdateSounds = await add_font_data(obj)
        }

        setIsModalLoading(false);
        if (createUpdateSounds) {
            const { message, status } = createUpdateSounds;
            if (status) {
                toast.success(message);
                handleClose();
                setDeleteUpdateTag(deleteUpdateYes);
            } else {
                toast.error(message);
            };
        }
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "690px",
                            borderRadius: "12px"
                        },
                    },
                }}
            >
                <DialogTitle id="responsive-dialog-title" className='p-0 mb-[30px] text-[#1E1627]'>
                    {
                        addEditDeleteTag === 'view' ? 'Details View' : addEditDeleteTag === 'update' ? `Edit Font ` : `Add Font `
                    }

                </DialogTitle>
                <DialogContent>
                    <div>
                        {
                            <form onSubmit={handleSubmit}>
                                <div className='add-edit-form'>
                                    <div className='grid grid-cols-1 lg:grid-cols-2 gap-5'>
                                        <div className='lg:col-span-1'>
                                            <Typography className="text-lg text-[#1E1627] font-medium">Small Preview  <span className='text-red-800'>*</span></Typography>
                                            <div className='w-auto'>
                                                <FileInput name={`fontSmallPreview`} imgClass={`h-40`} previewFields={'fontSmallPreview'} accept={'image/*'} acceptedExtensions={/\.(jpg|png|webp)$/} required validation={false} />
                                            </div>
                                        </div>

                                        <div className='lg:col-span-1'>
                                            <Typography className="text-lg text-[#1E1627] font-medium">Big Preview  <span className='text-red-800'>*</span></Typography>
                                            <div className='w-auto'>
                                                <FileInput name={`fontBigPreview`} imgClass={`h-40`} previewFields={'fontBigPreview'} accept={'image/*'} acceptedExtensions={/\.(jpg|png|webp)$/} required validation={false} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-span-6 sm:col-span-6">
                                        <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">name:<span className='text-red-800'>*</span></label>
                                        <div className="mt-1">
                                            <Input id='name' placeholder='Enter name' name='name' onChange={handleChange} value={formData?.name} autoComplete='off' required={true} />
                                        </div>
                                    </div>

                                    <div className="col-span-6  sm:col-span-3 mt-3">
                                        <label htmlFor="themeFont" className="block text-sm font-medium leading-6 text-gray-900">Upload Font File :<span className='text-red-800'>*</span></label>
                                        <div className="mt-2 relative">
                                            <input id='themeFont' type='file' accept='.ttf' name='themeFont'
                                                onChange={handleFileInput} />
                                            {
                                                addEditDeleteTag === `update` && formData.themeFont && typeof formData.themeFont === 'string'
                                                && formData.themeFont &&
                                                <label htmlFor="themeFont" className='absolute sm:left-[37%] left-[37.5%] right-[2px] w-auto rounded-r-[7px] border-1 border-white text-sm leading-none bg-white h-[90%] top-0 bottom-0 m-auto flex items-center pl-1'>{truncateString(formData.themeFont.split('/').pop(), 20)}</label>

                                            }
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-6 lg:grid-cols-6 gap-5  mt-3">

                                        <div className="col-span-2 sm:col-span-1">
                                            <label htmlFor="isPremium" className="block text-sm font-medium leading-6 text-gray-900">isPremium:</label>
                                            <div className="mt-1.5">
                                                <Switch color='green' id='isPremium' name='isPremium' onChange={handleSwitch} checked={formData?.isPremium} />
                                            </div>
                                        </div>
                                        <div className="col-span-2 sm:col-span-1">
                                            <label htmlFor="isHot" className="block text-sm font-medium leading-6 text-gray-900">isHot:</label>
                                            <div className="mt-1.5">

                                                <Switch color='green' id='isHot' name='isHot' onChange={handleSwitch} checked={formData?.isHot} />
                                            </div>
                                        </div>
                                        <div className="col-span-2 sm:col-span-1">
                                            <label htmlFor="isLatest" className="block text-sm font-medium leading-6 text-gray-900">isLatest:</label>
                                            <div className="mt-1.5">
                                                <Switch color='green' id='isLatest' name='isLatest' onChange={handleSwitch} checked={formData?.isLatest} />
                                            </div>
                                        </div>
                                        <div className="col-span-2 sm:col-span-1">
                                            <label htmlFor="isActive" className="block text-sm font-medium leading-6 text-gray-900">isActive:</label>
                                            <div className="mt-1.5">
                                                <Switch color='green' id='isActive' name='isActive' onChange={handleSwitch} checked={formData?.isActive} />
                                            </div>
                                        </div>
                                        <div className="col-span-2 sm:col-span-1">
                                            <label htmlFor="isTop" className="block text-sm font-medium leading-6 text-gray-900">isTop:</label>
                                            <div className="mt-1.5">
                                                <Switch color='green' id='isTop' name='isTop' onChange={handleSwitch} checked={formData?.isTop} />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className='flex justify-end mt-5'>
                                    <Button
                                        onClick={handleClose}
                                        className="mr-2.5 px-5 py-2.5 bg-white shadow-none text-[#1E3354] font-medium border border-[#75869F] hover:shadow-none capitalize text-base"
                                    >
                                        <span>Cancel</span>
                                    </Button>
                                    <Button
                                        disabled={isModalLoading}
                                        className="flex items-center mr-1 px-5 py-2.5 bg-[#0047FF] shadow-none text-white font-medium border border-[#0047FF] hover:shadow-none capitalize text-base"
                                        type='submit'
                                    >
                                        {isModalLoading && <Spinner className="h-4 w-4" />}
                                        <span className={isModalLoading ? 'ml-4' : ''}>{addEditDeleteTag === `update` ? `Update` : `Add`}</span>
                                    </Button>
                                </div>
                            </form>
                        }
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default ThemeFontModel
